import React, { useContext, useState } from 'react'
import { firestore, storage } from '../../firebase-init'
import { FirestoreContext } from '../../providers/firestore-provider'
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
import PhotoCamera from '@material-ui/icons/PhotoCamera'
import Avatar from '@material-ui/core/Avatar'
import Badge from '@material-ui/core/Badge'
import Box from '@material-ui/core/Box'
import { useDispatch } from 'react-redux'
import { openSnackbar } from '../../ducks/snackbar/actions'
import { Loading } from '../../components'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    displayNameInput: {
      margin: theme.spacing(3, 0),
    },
    btnContainer: {
      marginTop: theme.spacing(4, 0, 0, 0),
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    inputContainer: {
      margin: theme.spacing(3, 0),
    },
    uploadInput: {
      display: 'none',
    },
    avatarContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    largeSizeImg: {
      width: theme.spacing(8),
      height: theme.spacing(8),
    },
    smallAvatart: {
      width: '18px',
      height: '18zpx',
      borderRadius: '50%',
      backgroundColor: '#FFFFFF',
      border: `2px solid ${theme.palette.background.paper}`,
    },
    uploadLabel: {
      cursor: 'pointer',
      margin: theme.spacing(0, 0, 2, 0),
    },
    inputsContainer: {
      margin: theme.spacing(3, 0),
    },
  })
)

export const AccountSettingsPage = () => {
  const dispatch = useDispatch()
  const { currentUser } = useContext(FirestoreContext)
  const [loading, setLoading] = useState(false)
  const [displayName, setDisplayName] = useState(currentUser?.displayName || '')
  const [imageUrl, setImageUrl] = useState(currentUser?.photoURL || ('' as any))
  const [file, setFile] = useState('' as any)
  const id = currentUser?.id
  const userRef = firestore.collection('users').doc(id!)

  const onChangeDisplayName = (event: React.ChangeEvent<HTMLInputElement>) => {
    setDisplayName(event.target.value)
  }

  const onChangeFile = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0]
      const reader = new FileReader()
      reader.readAsDataURL(file) as any

      reader.onloadend = function () {
        // Picture is smaller than 10mb
        if (file.size < 10 * 1024 * 1024) {
          setFile(file)
          setImageUrl(reader.result)
        } else {
          alert('Choose a picture with less than 10MB size')
        }
      }.bind(this)
    }
  }

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()

    if (loading) return

    try {
      setLoading(true)
      if (file && id) {
        storage
          .ref()
          .child('user-profiles')
          .child(id)
          .child(file.name!)
          .put(file)
          .then((response) => response.ref.getDownloadURL())
          .then(async (photoURL) => {
            await userRef.update({
              photoURL: photoURL || currentUser?.photoURL,
              displayName,
            })
            dispatch(openSnackbar('Your profile has been updated', 'success'))
          })
      } else {
        await userRef.update({
          displayName: displayName,
        })
        setLoading(false)
        dispatch(openSnackbar('Your profile has been updated', 'success'))
      }
    } catch (error) {
      setLoading(false)
      console.warn('Error: putting photo in the bucket or changing name ', error)
    }
  }

  const classes = useStyles()

  return (
    <Grid container>
      <Grid item xs={12}>
        {loading && <Loading />}
        <form
          onSubmit={handleSubmit}
          className="AddDose"
          style={{
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Box className={classes.avatarContainer}>
            <label className={classes.uploadLabel} htmlFor="icon-button-file">
              <Badge
                overlap="circle"
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'right',
                }}
                badgeContent={
                  <div className={classes.smallAvatart}>
                    <PhotoCamera style={{ fontSize: 18 }} />
                  </div>
                }
              >
                {imageUrl ? (
                  <Avatar
                    alt={currentUser?.displayName || currentUser?.username}
                    src={imageUrl}
                    className={classes.largeSizeImg}
                  />
                ) : (
                  <Avatar className={classes.largeSizeImg}>
                    {currentUser?.displayName?.charAt(0)?.toUpperCase()}
                  </Avatar>
                )}
              </Badge>
            </label>
            <input
              accept="image/*"
              className={classes.uploadInput}
              id="icon-button-file"
              type="file"
              onChange={onChangeFile}
            />
          </Box>
          <Box mb={2}>
            <TextField
              label="Email"
              id="email"
              defaultValue={currentUser?.email}
              margin="normal"
              variant="outlined"
              disabled
              fullWidth={true}
            />

            <TextField
              label="User name"
              id="userName"
              defaultValue={currentUser?.username}
              margin="normal"
              variant="outlined"
              fullWidth={true}
              disabled
            />

            <TextField
              label="Display Name"
              id="displayName"
              defaultValue={currentUser?.displayName}
              margin="normal"
              variant="outlined"
              fullWidth={true}
              onChange={onChangeDisplayName}
            />
          </Box>
          <Box className={classes.btnContainer}>
            <Button color="primary" type="submit" variant="contained">
              Save
            </Button>
          </Box>
        </form>
      </Grid>
    </Grid>
  )
}
